/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import { HELPERS } from '../../helpers/index.js';
import type { UpdateProfileResponse, UpdateProfileVars } from '../openapi-types.gen.js';

export type { UpdateProfileResponse, UpdateProfileVars } from '../openapi-types.gen.js';

export const useUpdateProfile = createMutationHook<UpdateProfileVars, UpdateProfileResponse, unknown>({
  specName: 'useUpdateProfile',
  path: '/v1/me',
  method: 'PATCH',
  resolveUrl: (vars: UpdateProfileVars) => `/v1/me`,
  buildBody: (vars: UpdateProfileVars) => ({ displayName: vars.displayName, handle: vars.handle, avatarUrl: vars.avatarUrl, avatarPreferences: vars.avatarPreferences, heroUrl: vars.heroUrl, bio: vars.bio, email: vars.email, phoneNumber: vars.phoneNumber, interestTopics: vars.interestTopics, interestPlatforms: vars.interestPlatforms, onboardingCompleted: vars.onboardingCompleted }),
  parseResponse: (raw: unknown): UpdateProfileResponse => raw as UpdateProfileResponse,
  optimistic: [{
    queryKey: ['accounts', 'viewer'],
    entityGraph: true,
    reconcileQueryKey: ['me', 'detail'],
    reconcileSpecName: 'useGetMe',
    apply: (prev: any, vars: UpdateProfileVars, queryKey: readonly unknown[], queryClient: any, viewerScope: string, networkScope: string) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      next = (HELPERS.applyPrivateAccountProfileOptimistic as unknown as (prev: any, vars: UpdateProfileVars, queryKey: readonly unknown[], queryClient: any, viewerScope: string, networkScope: string) => any)(next, vars, queryKey, queryClient, viewerScope, networkScope);
      return next;
    },
  }, {
    queryKey: ['users', 'entity'],
    reconcile: false,
    entityGraph: true,
    apply: (prev: any, vars: UpdateProfileVars, queryKey: readonly unknown[], queryClient: any) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      next = (HELPERS.applyPublicUserProfileOptimistic as unknown as (prev: any, vars: UpdateProfileVars, queryKey: readonly unknown[], queryClient: any) => any)(next, vars, queryKey, queryClient);
      return next;
    },
  }],
  
  
});
